<template>
  <span>
    <slot name="button" v-bind="{onclick: toggle}">
      <b-button variant="primary" class="mr-1" size="xs" @click="toggle"><i class="fas fa-edit"></i>&nbsp;Edit</b-button>
    </slot>

    <b-modal
        @show="resetModal"
        @hidden="resetModal"
        ref="modal-container"
        v-model="modalShow"
        size="lg"
        :title="title"
        :static="true"
        :lazy="true"
        hide-footer
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group v-if="!this.create" label="_ID" label-for="id-input">
          <b-form-input id="id-input"
                        v-model="formValues.id"
                        autocomplete="off"
                        disabled
          />
        </b-form-group>

        <b-form-group label="Proxy ID" label-for="proxy-id">
          <b-form-input id="proxyId"
                        type="number"
                        v-model="formValues.proxyId"
                        v-validate="{required: true, numeric: true}"
                        :state="validateState('proxyId')"
                        aria-describedby="proxyId-live-feedback"
                        data-vv-name="proxyId"
                        data-vv-as="Proxy ID"
                        autocomplete="off"
                        required
                        :disabled="!this.create"
          />
          <b-form-invalid-feedback id="proxyId-live-feedback">{{ veeErrors.first('proxyId') }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Source" label-for="source-input">
          <b-form-input id="source-input"
                        type="text"
                        v-model="formValues.source"
                        v-validate="{url: {require_protocol: true }, required: true}"
                        :state="validateState('source')"
                        aria-describedby="source-live-feedback"
                        data-vv-name="source"
                        data-vv-as="Source"
                        autocomplete="off"
                        required
          />
          <b-form-invalid-feedback id="source-live-feedback">{{ veeErrors.first('source') }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Type" label-for="sources-input">
          <b-form-select v-model="formValues.type"
                         :options="typeOptions"
                         required
          />
        </b-form-group>
      </form>

      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit">Save</b-button>
    </b-modal>
  </span>
</template>

<script>
import Multiselect from 'vue-multiselect';
import VJsoneditor from "v-jsoneditor/src/index";
import Vue from "vue";

export default {
  data() {
    return {
      modalShow: false,
      formValues: this.getInitialValues(),
      typeOptions: [
          { value: 1, text: 'SocketIo 2.3.0' },
      ],
    }
  },
  components: {
    Multiselect,
    VJsoneditor,
  },
  props: {
    create: Boolean,
    title: String,
    defaultValues: Object
  },
  methods: {
    getInitialValues() {
      return {
        id: null,
        source: null,
        proxyId: null,
        type: null,
      };
    },
    setDefaults() {
      let initialValues = this.getInitialValues();

      for (let field in initialValues) {
        Vue.set(this.formValues, field, initialValues[field]);
      }

      if (this.defaultValues) {
        for (let field in this.defaultValues) {
          Vue.set(this.formValues, field, this.defaultValues[field]);
        }
      }
    },
    validateState(ref) {
      if (
          this.veeFields[ref] &&
          (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    resetModal() {
      this.setDefaults();
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    handleSubmit() {
      for (let key of Object.keys(this.formValues)) {
        if (typeof this.formValues[key] === 'string') {
          this.formValues[key] = this.formValues[key].trim();
        }
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        this
            .$http({
              url: this.create ? '/api/v1/proxies' : '/api/v1/proxies/' + this.formValues.proxyId,
              data: {
                ...this.formValues,
                proxyId: Number.parseInt(this.formValues.proxyId),
              },
              method: this.create ? 'POST' : 'PUT',
              headers: {
                'Content-Type': 'application/json',
              },
            })
            .then(() => {
              setTimeout(() => {
                this.$emit('finish');
              }, 500);

              this.hideModal();
              this.$toastr.i('Success');
            })
            .catch((err) => {
              let message;

              if (typeof err.response.data.message === 'string') {
                message = err.response.data.message;
              } else {
                message = JSON.stringify(err.response.data.message);
              }

              this.$toastr.e(message);

              throw err;
            });
      });
    },
  },
  mounted() {
    this.setDefaults();
  },
}
</script>
